// extracted by mini-css-extract-plugin
export default {"card":"PatientInfo_card__MBYhx","title":"PatientInfo_title__rnkmk","info":"PatientInfo_info__i75rA","loading":"PatientInfo_loading__r5Xm4"};